import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireRole = ({ role, allowedRoles, children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has any of the allowed roles
  const hasPermission = () => {
    // If specific role is required
    if (role) {
      return user?.role === role;
    }
    
    // If multiple roles are allowed
    if (allowedRoles && Array.isArray(allowedRoles)) {
      return allowedRoles.includes(user?.role);
    }
    
    // If no role restrictions, allow authenticated users
    return true;
  };

  if (!hasPermission()) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">Access Denied</h2>
          <p className="text-gray-600 dark:text-gray-400">You don't have permission to access this page.</p>
          <a href="/" className="text-blue-600 dark:text-blue-400 hover:underline mt-4 inline-block">
            Return to Home
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default RequireRole;
